import React, { useState } from "react";
import { Maybe, RetirementDetails } from "@/apollo/types";
import {
  HoverCard,
  HoverCardContent,
  HoverCardPortal,
  HoverCardTrigger,
} from "@/components/elements/HoverCard";
import { formatDate } from "@/shared/formatters";
import { Button } from "@/components/elements/Button";
import { ExternalLink } from "lucide-react";

export const DeprecatedHoverCard = (props: {
  retirementDetails?: Maybe<RetirementDetails>;
  tableName?: string;
  children: React.ReactElement;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <HoverCard
      openDelay={100}
      closeDelay={100}
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <HoverCardTrigger tabIndex={0} asChild>
        {props.children}
      </HoverCardTrigger>
      <HoverCardPortal>
        <HoverCardContent side="top" className="w-80 p-3">
          <div className="space-y-4 text-sm">
            {props.tableName && (
              <header className="truncate font-semibold">
                {props.tableName}
              </header>
            )}
            <div>
              This table has been deprecated and
              {props.retirementDetails?.removalDate ? (
                <>
                  {" "}
                  will stop syncing after{" "}
                  <strong>
                    {formatDate(props.retirementDetails.removalDate)}
                  </strong>
                </>
              ) : (
                "  will eventually stop syncing"
              )}
              .
            </div>
            {props.retirementDetails?.inFavorOf && (
              <div>
                Switch to the <code>{props.retirementDetails.inFavorOf}</code>{" "}
                table to continue receiving data.
              </div>
            )}
            {props.retirementDetails?.details && (
              <div>
                <div className="font-bold">Additional details</div>
                <div>{props.retirementDetails.details}</div>
              </div>
            )}
            {props.retirementDetails?.link && (
              <footer className="flex justify-center">
                <Button
                  size="xs"
                  icon={<ExternalLink />}
                  variant="solid"
                  href={props.retirementDetails.link}
                  as="a"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    setIsOpen(false);
                  }}
                >
                  Official Documentation
                </Button>
              </footer>
            )}
          </div>
        </HoverCardContent>
      </HoverCardPortal>
    </HoverCard>
  );
};
